import { render } from "./Modal.vue?vue&type=template&id=5b20f1a6&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=5b20f1a6&lang=scss&scoped=true"

import exportComponent from "/home/forge/empireresidential.net/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b20f1a6"]])

export default __exports__